export default __webpack_public_path__ + "static/media/regulatory--pedestrians-priority-zone--g1.a5b6727e.png";